import _ from 'lodash';
import objectAssign from 'object-assign';
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions/userActions';
import * as clubActions from '../../actions/clubActions';
import * as eventActions from '../../actions/eventActions';
// import * as clubActions from '../../actions/clubActions';
import { Link } from 'react-router';
// import * as utils from '../../components/common/utils';
import TextInput from '../../components/common/TextInput';
import PasswordInput from '../../components/common/PasswordInput';
import * as perm from '../../permission';
// import DateInput from '../../components/common/DateInput';
import AdminTable from '../../components/users/AdminTable';
import Loading from '../../components/Loading';
import FontAwesome from 'react-fontawesome';
import toastr from 'toastr';

class ManageUserPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
    this.componentWillMount = this.componentWillMount.bind(this);
    this.shouldUpdateDetails = this.shouldUpdateDetails.bind(this);
    this.delete = this.delete.bind(this);
    this.updateField = this.updateField.bind(this);
    this.toggleBooleanField = this.toggleBooleanField.bind(this);
    this.updatePasswordField = this.updatePasswordField.bind(this);
    this.updateDateField = this.updateDateField.bind(this);
    this.submitDetailsForm = this.submitDetailsForm.bind(this);
    this.submitPasswordForm = this.submitPasswordForm.bind(this);
    this.askBeforeExit = this.askBeforeExit.bind(this);
    let details = {};
    let errors = {};
    this.state = {
      initialLoading: !!props.userId,
      passwordDetails: {
        password: "",
        password_validation: "",
      },
      details: details,
      loading: false,
      errors: errors,
    };
  }

  componentWillMount() {
    // && this.props.userId != this.props.details.id
    if(this.props.userId) {
      this.props.actions.loadUserDetails(this.props.userId);
    }
    if(perm.hasGlobalPermission(this.props.currentUser, ['super_admin', 'club_admin'])) {
      this.props.clubActions.loadClubs();
    }
    if(perm.hasGlobalPermission(this.props.currentUser, ['super_admin', 'event_admin'])) {
      this.props.eventActions.loadEvents();
    }
    if(perm.hasGlobalPermission(this.props.currentUser, ['super_admin'])) {
      this.props.actions.loadGroups();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userId && nextProps.userId != this.props.userId) {
      this.props.actions.loadUserDetails(nextProps.userId);
    }
    if(this.shouldUpdateDetails(nextProps)) {
      this.setState({
        details: nextProps.details,
        passwordDetails: {},
        initialLoading: false,
        loading: nextProps.loading,
      });
    } else if(!_.isEqual(this.props.errors, nextProps.errors)) {
      this.setState({
        loading: false,
        initialLoading: false,
        errors: nextProps.errors,
      });
    }
  }

  shouldUpdateDetails(nextProps) {
    let p = this.props;
    let updated = p.detailsUpdated !== nextProps.detailsUpdated;
    return _.every([updated], (item) => item === true);
  }

  delete(e) {
    if (!confirm('Bekreft at du ønsker å slette')) {
      e.preventDefault();
      return false;
    }
    this.props.actions.deleteUser(this.props.userId);
  }

  updateField(e) {
    let details = objectAssign({}, this.state.details);
    details[e.target.name] = e.target.value;
    return this.setState({
      details: details
    });
  }

  updatePasswordField(e) {
    let passwordDetails = objectAssign({}, this.state.passwordDetails);
    passwordDetails[e.target.name] = e.target.value;
    return this.setState({
      passwordDetails: passwordDetails
    });
  }

  updateDateField(field, date) {
    let details = objectAssign({}, this.state.details);
    details[field] = date;
    return this.setState({
      details: details
    });
  }

  toggleBooleanField(e, array_field) {
    let details = objectAssign({}, this.state.details);
    let array = objectAssign([], details[array_field]);
    let id = Number(e.target.value);
    let index = array.indexOf(id);
    if (index === -1) {
        array.push(id);
    } else {
        array.splice(index, 1);
    }
    details[array_field] = array;
    return this.setState({
      details: details
    });
  }

  submitDetailsForm(event) {
    toastr.info('Lagrer');
    this.setState({
      loading: true,
    });
    if (this.props.userId) {
      this.props.actions.updateUser(this.state.details);
    } else {
      this.props.actions.createUser(this.state.details);
    }
    event.preventDefault();
  }

  submitPasswordForm(event) {
    toastr.info('Lagrer passord');
    this.setState({
      loading: true,
    });
    this.props.actions.updatePassword(
      this.props.userId,
      this.state.passwordDetails);
    event.preventDefault();
  }

  askBeforeExit(e) {
    let changed = !_.isEqual(this.props.details, this.state.details);
    if (changed && !confirm('Ønsker du å gå tilbake uten å lagre?')) {
      e.preventDefault();
      return false;
    }
  }

  render() {
    let details = this.state.details;
    if (this.state.initialLoading) {
      return (
        <div className="member-page-container container">
          <Loading loading={this.props.loading} className="center-loading" size="3x"/>
        </div>);
    }
    return (
      <div className="member-page-container container">
        <div className="row">
          <div className="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
            <div className="panel panel-default">
              <form onSubmit={this.submitDetailsForm}>
                <div className="panel-body">
                    <input type="submit" value="submit" className="hidden"/>
                    <TextInput
                      name="first_name"
                      label="Fornavn"
                      error={this.state.errors.first_name}
                      placeholder="Fornavn"
                      onChange={this.updateField}
                      value={details.first_name}
                      />
                    <TextInput
                      name="last_name"
                      label="Etternavn"
                      error={this.state.errors.last_name}
                      placeholder="Etternavn"
                      onChange={this.updateField}
                      value={details.last_name}
                      />
                    <TextInput
                      name="username"
                      label="Brukernavn"
                      error={this.state.errors.username}
                      placeholder="Brukernavn"
                      onChange={this.updateField}
                      value={details.username}
                      />
                    <TextInput
                      name="email"
                      label="Epost"
                      error={this.state.errors.email}
                      placeholder="Epost"
                      onChange={this.updateField}
                      value={details.email}
                      />
                    {!this.props.userId &&
                      <div>
                        <PasswordInput
                          name="password"
                          label="Passord"
                          error={this.state.errors.password}
                          placeholder="Passord"
                          onChange={this.updateField}
                          value={details.password}
                          />
                        <PasswordInput
                          name="password_validation"
                          label="Gjenta passord"
                          error={this.state.errors.password_validation}
                          placeholder="Gjenta passord"
                          onChange={this.updateField}
                          value={details.password_validation}
                          />
                      </div>}
                  </div>
                <div className="panel-footer clearfix">
                  {perm.hasGlobalPermission(this.props.currentUser, ['super_admin']) &&
                    <Link className="btn btn-default"
                    to={'/brukere'}
                    onClick={this.askBeforeExit}>
                    Tilbake
                  </Link>}
                  <span className="pull-right">
                    <button className="btn btn-primary"
                      disabled={this.state.loading}
                      onClick={this.submitDetailsForm} >
                      <FontAwesome name="save" />
                      {' Lagre'}
                    </button>
                  </span>
                </div>
              </form>
            </div>

            {this.props.userId && <div className="panel panel-default">
              <form onSubmit={this.submitPasswordForm}>
                <div className="panel-body">
                  <input type="submit" value="submit" className="hidden"/>
                  <h3 className="page-header">
                    Endre passord
                  </h3>
                  <PasswordInput
                    name="password"
                    label="Passord"
                    error={this.state.errors.password}
                    placeholder="Passord"
                    onChange={this.updatePasswordField}
                    value={this.state.passwordDetails.password}
                    />
                  <PasswordInput
                    name="password_validation"
                    label="Gjenta passord"
                    error={this.state.errors.password_validation}
                    placeholder="Gjenta passord"
                    onChange={this.updatePasswordField}
                    value={this.state.passwordDetails.password_validation}
                    />
                </div>
                <div className="panel-footer clearfix">
                  <span className="pull-right">
                    <button className="btn btn-primary"
                      disabled={this.state.loading}
                      onClick={this.submitPasswordForm} >
                      <FontAwesome name="save" />
                      {' Endre passord'}
                    </button>
                  </span>
                </div>
              </form>
            </div>}
            {this.props.userId && perm.hasGlobalPermission(this.props.currentUser, ['super_admin']) &&
              <div>
                <AdminTable
                  heading={'Klubber '}
                  checked={this.state.details.clubs}
                  list={this.props.clubList}
                  listName={'clubs'}
                  onChange={this.toggleBooleanField}/>
                <span className="pull-right">
                  <button className="btn btn-primary"
                    disabled={this.state.loading}
                    onClick={this.submitDetailsForm} >
                    <FontAwesome name="save" />
                    {' Lagre'}
                  </button>
                </span>
              </div>
            }
            {this.props.userId && perm.hasGlobalPermission(this.props.currentUser, ['super_admin']) &&
              <div>
                <AdminTable
                  heading={'Arrangementer '}
                  checked={this.state.details.events}
                  list={this.props.eventList}
                  listName={'events'}
                  onChange={this.toggleBooleanField}/>
                <span className="pull-right">
                  <button className="btn btn-primary"
                    disabled={this.state.loading}
                    onClick={this.submitDetailsForm} >
                    <FontAwesome name="save" />
                    {' Lagre'}
                  </button>
                </span>
              </div>
            }
            {this.props.userId && perm.hasGlobalPermission(this.props.currentUser, ['super_admin']) &&
              <div>
                <AdminTable
                  heading={'Admin gruppe'}
                  checked={this.state.details.groups}
                  list={this.props.groups}
                  listName={'groups'}
                  onChange={this.toggleBooleanField}/>
                <span className="pull-right">
                  <button className="btn btn-primary"
                    disabled={this.state.loading}
                    onClick={this.submitDetailsForm} >
                    <FontAwesome name="save" />
                    {' Lagre'}
                  </button>
                </span>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

ManageUserPage.propTypes = {
  actions: PropTypes.object.isRequired,
  clubActions: PropTypes.object.isRequired,
  eventActions: PropTypes.object.isRequired,
  details: PropTypes.object.isRequired,
  clubList: PropTypes.array.isRequired,
  eventList: PropTypes.array.isRequired,
  groups: PropTypes.array.isRequired,
  userId: PropTypes.string,
  currentUser: PropTypes.object.isRequired,
  errors: PropTypes.object,
  detailsUpdated: PropTypes.number,
  loading: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  return {
    userId: ownProps.params.userId,
    loading: state.users.loading,
    details: state.users.details,
    groups: state.users.groups,
    currentUser: state.users.currentUser,
    clubList: state.clubs.clubList,
    eventList: state.events.eventList,
    errors: state.users.errors,
    detailsUpdated: state.users.detailsUpdated,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    clubActions: bindActionCreators(clubActions, dispatch),
    eventActions: bindActionCreators(eventActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageUserPage);



/** WEBPACK FOOTER **
 ** ./src/containers/users/ManageUserPage.js
 **/